import React from 'react';
import { useTranslation } from 'react-i18next';
import { legalEn } from '../../i18n/locales/legal/en';
import { legalIt } from '../../i18n/locales/legal/it';
import { Building2, Phone, Mail, Globe, FileText } from 'lucide-react';

export function TermsPage() {
  const { i18n } = useTranslation();
  const legal = i18n.language === 'it' ? legalIt : legalEn;

  return (
    <div className="pt-16">
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-4">{legal.terms.title}</h1>
          <p className="text-xl text-blue-100">{legal.terms.lastUpdated}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          {/* Company Info */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
                  <Building2 className="w-6 h-6 text-blue-600" />
                  {legal.company.name}
                </h2>
                <div className="space-y-4">
                  <p className="text-gray-600">
                    <span className="font-semibold">Trading as:</span><br />
                    {legal.company.dba.join(', ')}
                  </p>
                  <p className="text-gray-600">
                    <span className="font-semibold">Address:</span><br />
                    {legal.company.address}
                  </p>
                </div>
              </div>
              <div className="space-y-6">
                <div className="flex items-center gap-3">
                  <FileText className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <div>
                    <p className="text-gray-600">
                      <span className="font-semibold">VAT:</span> {legal.company.vat}
                    </p>
                    <p className="text-gray-600">
                      <span className="font-semibold">REA:</span> {legal.company.rea}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <p className="text-gray-600">{legal.company.phone}</p>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <p className="text-gray-600">{legal.company.email}</p>
                </div>
                <div className="flex items-center gap-3">
                  <Globe className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <p className="text-gray-600">{legal.company.website}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Introduction */}
          <div className="mb-12">
            <p className="text-gray-700">{legal.terms.introduction}</p>
          </div>

          {/* Terms Sections */}
          {legal.terms.sections.map((section, index) => (
            <div key={index} className="mb-8">
              <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
              <div className="text-gray-600 whitespace-pre-line">{section.content}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}